import { MuiStylesType } from 'model/muiStyles.model';

export const muiStyles: MuiStylesType = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    minWidth: '310px',
    overflow: 'scroll',
    flex: 1,
  },
};
